/*eslint-disable*/
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React, { useState, useContext, useCallback } from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  CssBaseline,
  Drawer,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "common";
import AppMenu from "../views/AppMenu";
import { language } from "config";
import Tooltip from "@material-ui/core/Tooltip";
import { useLocation } from "react-router-dom";
const drawerWidthExpanded = 260;
const drawerWidthCollapsed = 100;

// const drawerWidthCollapsed = 80; // <- was 100
// const drawerWidthExpanded = 260;
const useStyles = makeStyles((theme) => ({
  root: {
    //display: "flex",
    minHeight: "100vh",
  },

  drawer: (props) => ({
    [theme.breakpoints.up("sm")]: {
      width: props.isDrawerCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
      flexShrink: 0,
    },
  }),

  drawerPaper: (props) => ({
    width: props.isDrawerCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
    backgroundColor: "#009ad8",
    color: "white",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("xs")]: {
      width: "100%", // Full width on very small screens
    },
  }),

  tooltip: {
    fontSize: "clamp(0.9rem, 1.2vw, 1.2rem)",
    backgroundColor: "white",
    color: "#399ddb",
    borderRadius: 4,
    padding: "8px 14px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
  },

  appBar: (props) => ({
  marginLeft: props.isDrawerCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
  width: `calc(100% - ${
    props.isDrawerCollapsed ? drawerWidthCollapsed : drawerWidthExpanded
  }px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#399ddb",
    color: "#ffffff",
    height: "64px",
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      width: "100%",
    },
  }),

  title: {
    fontSize: "clamp(1.2rem, 2vw, 1.6rem)",
    fontWeight: 500,
  },

  toolbar: {
    ...theme.mixins.toolbar,
    minHeight: "64px",
    display: "flex",
    alignItems: "center",
    //padding: theme.spacing(0, 2),
    [theme.breakpoints.up("md")]: {
      minHeight: "80px",
    },
  },

  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },

  content: (props) => ({
    flexGrow: 1,
    //padding: theme.spacing(3),
    marginLeft: props.isDrawerCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.standard,
    }),
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      //padding: theme.spacing(2),
    },
  }),

  appBarIcons: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "clamp(2rem, 3vw, 3rem)",
  },

  appBarIcon: {
    color: "#ffffff",
    marginRight: theme.spacing(1),
    height: "64px",
    fontSize: "clamp(2rem, 4vw, 3.5rem)",
  },
}));


function ResponsiveDrawer(props) {
  const { container } = props;
  const [isDrawerCollapsed, setIsDrawerCollapsed] = useState(false);
  const classes = useStyles({ isDrawerCollapsed });
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const { api } = useContext(FirebaseContext);
  const { signOut, sendResetMail } = api;
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [fpEmail, setFpEmail] = React.useState("");
  const [openFPModal, setOpenFPModal] = React.useState(false);

  const location = useLocation();


  const getPageTitle = (pathname) => {
    const titles = {
      "/": "Home",
      "/dashboard": "Dashboard",
      "/manageadmins": "Manage Admins",
      "/profile": "Profile",
      "/branches": "Branch Management",
      "/manageLandlords": "Manage Landlords",
      "/editprofile": "Edit Profile",
      "/adduseradmin": "Add User",
      "/staff": "Add Brokers",
      "/addtenantadmin": "Add Tenant",
      "/staffcalendar": "Calendar",
      "/brokerprofile": "Profile",
      "/editbrokerprofile": "Edit Profile",
      "/brokerenquiries": "Enquiries",
      "/stock": "Listings",
    };

    return titles[pathname] || "API PROPERTY";
  };
  //keep below the method
  const pageTitle = getPageTitle(location.pathname);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleDrawer = useCallback(() => {
    setIsDrawerCollapsed((prev) => !prev);
  }, []);

  const handleLogout = () => {
    dispatch(signOut());
    navigate("/");
  };

  const handleProfileClick = () => {
    navigate("/profile");
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileEditClick = () => {
    navigate("/editprofile");
  };

  const handleCloseFP = (e) => {
    e.preventDefault();
    setFpEmail("");
    setOpenFPModal(false);
  };

  const handleResetPasswordClick = (e) => {
    e.preventDefault();
    if (auth.info && auth.info.profile && auth.info.profile.email) {
      setFpEmail(auth.info.profile.email);
      setOpenFPModal(true);
    } else {
      console.error("User email not found in profile");
    }
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    dispatch(sendResetMail(fpEmail));
    setFpEmail("");
    setOpenFPModal(false);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" noWrap className={classes.title}>
            {pageTitle}
          </Typography>

          <div className={classes.appBarIcons}>


            <Tooltip title="Profile" placement="top" arrow classes={{ tooltip: classes.tooltip }}>
              <IconButton
                aria-label="account"
                onClick={handleProfileMenuOpen}
                color="inherit"
                className={classes.appBarIcon}
              >
                <AccountCircle />
              </IconButton>
            </Tooltip>

            <Tooltip title="Logout" placement="top" arrow classes={{ tooltip: classes.tooltip }}>
              <IconButton
                aria-label="logout"
                onClick={handleLogout}
                color="inherit"
                className={classes.appBarIcon}
              >
                <ExitToAppIcon />
              </IconButton>
            </Tooltip>
          </div>
        </Toolbar>
      </AppBar>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleProfileMenuClose}
        keepMounted
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            borderRadius: 8,
            padding: "4px 0",
            minWidth: 180,
          },
        }}
      >
        <MenuItem onClick={handleProfileClick} style={{ color: "#0784ba" }}>
          Profile
        </MenuItem>
        <MenuItem onClick={handleProfileEditClick} style={{ color: "#0784ba" }}>
          Profile Edit
        </MenuItem>
        {/* <MenuItem onClick={handleResetPasswordClick} style={{ color: "#0784ba" }}>
          Reset Password
        </MenuItem> */}
      </Menu>


      {/* 
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleProfileMenuClose}
        keepMounted
      >
        <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
        <MenuItem onClick={handleProfileEditClick}>Profile Edit</MenuItem>
        <MenuItem onClick={handleResetPasswordClick}>Reset Password</MenuItem>
      </Menu> */}

      <nav className={classes.drawer} aria-label="sidebar navigation">
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{ paper: classes.drawerPaper }}
            ModalProps={{ keepMounted: true }}
          >
            <AppMenu isCollapsed={false} toggleDrawer={toggleDrawer} />
          </Drawer>
        </Hidden>

        <Hidden xsDown implementation="css">
          <Drawer
            classes={{ paper: classes.drawerPaper }}
            variant="permanent"
            open
          >
            <AppMenu isCollapsed={isDrawerCollapsed} toggleDrawer={toggleDrawer} />
          </Drawer>
        </Hidden>
      </nav>

      <Dialog
        open={openFPModal}
        onClose={handleCloseFP}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
            minWidth: "400px",
          },
        }}
      >
        <DialogTitle
          id="form-dialog-title"
          style={{ fontWeight: 600, color: "#0784ba", marginBottom: "8px" }}
        >
          {language.forgot_pass_title}
        </DialogTitle>

        <DialogContent>
          <DialogContentText style={{ marginBottom: "16px", fontSize: "0.95rem", color: "#555" }}>
            {"A reset email will be sent to the email below"}
          </DialogContentText>

          <TextField
            autoFocus
            margin="dense"
            id="email"
            // label={"A reset email will be sent to the email below"}
            type="email"
            fullWidth
            value={fpEmail}
            onChange={(e) => setFpEmail(e.target.value)}
            disabled
            variant="outlined"
            InputProps={{
              style: {
                backgroundColor: "#f5f7fa",
              },
            }}
          />
        </DialogContent>

        <DialogActions style={{ padding: "16px" }}>
          <Button
            onClick={handleCloseFP}
            variant="outlined"
            style={{
              borderColor: "#0784ba",
              color: "#0784ba",
              textTransform: "none",
            }}
          >
            {language.cancel}
          </Button>
          <Button
            onClick={handleResetPassword}
            variant="contained"
            style={{
              backgroundColor: "#0784ba",
              color: "#fff",
              textTransform: "none",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            {language.reset_password}
          </Button>
        </DialogActions>
      </Dialog>

      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  container: PropTypes.instanceOf(
    typeof Element === "undefined" ? Object : Element
  ),
};

export default ResponsiveDrawer;